/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFAQ = {
  init: function() {

    const $faqHeading = $('.faq-accordion > dt > button');

    $('.faq-accordion > dd').attr('aria-hidden',true);

    $faqHeading.attr('aria-expanded',false);

    $faqHeading.unbind('click activate').on('click activate',function(){

      const faqTitle = $(this);
      const faqIcons = $(this).find('.icon');

      let state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded',state);
      $(this).parent().next().slideToggle(function(){

        if(faqIcons.hasClass('icon--active')) {
          faqIcons.toggleClass('icon--active');
        }

      });
        $(this).parent().next().attr('aria-hidden',!state);
      return false;
    });

    $faqHeading.on('keydown',function(event){
      let keyCode = event.keyCode || e.which;
      if (keyCode === 13){
        $(this).trigger('activate');
      }
    });

  },
  unload: function() {
    $('.faq-accordion > dt > button').off('click activate');
    $('.faq-accordion > dt > button').off('keydown');
  }
}

/******/ })()
;

	jQuery(document).ready(function() {
		
		jQuery(".faq-container > h3").on("click", function() {
			if (jQuery(this).hasClass("active")) {
				jQuery(this).removeClass("active");
				jQuery(this)
					.siblings(".faq-container .content")
					.slideUp(100);
				jQuery(".faq-container > h3 i")
					.removeClass("fa-minus")
					.addClass("fa-plus");
			} else {
				jQuery(".faq-container > h3 i")
					.removeClass("fa-minus")
					.addClass("fa-plus");
				jQuery(this)
					.find("i")
					.removeClass("fa-plus")
					.addClass("fa-minus");
				jQuery(".faq-container > h3").removeClass("active");
				jQuery(this).addClass("active");
				jQuery(".faq-container .content").slideUp(100);
				jQuery(this)
					.siblings(".faq-container .content")
					.slideDown(100);
			}
		});
	});